export default __webpack_public_path__ + "static/media/recent-on-blue.7dcc2909.svg";